
































import { LocationType } from '@/store/modules/admin/types/group-level-attribute.types';
import { Vue, Component, Emit, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class LocationAttributeRadioSelection extends Vue {
  @Prop({ default: false }) disabled!: boolean;
  @Prop() initialLocation!: LocationType;
  selectedLocation: LocationType = LocationType.VENUE;

  get LocationType() {
    return LocationType;
  }

  @Watch('selectedLocation')
  onValueChanged() {
    this.emitLocationType();
  }

  @Watch('initialLocation', { immediate: true })
  initialValueProvided() {
    this.selectedLocation = this.initialLocation;
  }

  @Emit('handleLocationUpdate')
  emitLocationType() {
    return this.selectedLocation;
  }
}
